<app-common-bulk-select-employee-dialog
    #selectEmployees
    headerText="time-tracking.addOrRemoveEmployees"
    [label]="'save' | appTranslate"
    [additionalQueryFilters]="[whereOnTimeTracking]"
    [tooltipTextMaker]="tooltipTextMaker"
>
</app-common-bulk-select-employee-dialog>

<!-- This is a modal that is used to confirm the removal of employees from the project. -->
<!-- It needs to work for single removal from the table and removal from the employee select modal. -->
<!-- There are a surprising number of variations, so be careful if changing the logic. -->
<ui-confirmation-dialog
    header="time-tracking.confirmAction"
    [primaryButtonLabel]="removeOrConfirmLabel"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmRemoveModal
>
    <!-- This is the logic for when there is only a single employee. -->
    <ng-container *ngIf="employeesPendingRemoval.length === 1">
        <ui-banner *ngIf="employeesPendingRemovalWithPendingHours.length" variant="warning" class="margin-bottom-3"
            >{{ 'time-tracking.removeFromProjectModal.singular.bannerWarning' | appTranslate }}
        </ui-banner>

        <p *ngIf="employeesPendingRemovalWithPendingHours.length">
            {{ 'time-tracking.removeFromProjectModal.singular.firstIfPendingHours' | appTranslate }}
        </p>
        <p *ngIf="!employeesPendingRemovalWithPendingHours.length">
            {{ 'time-tracking.removeFromProjectModal.singular.firstIfNoPendingHours' | appTranslate }}
        </p>
        <p>{{ 'time-tracking.removeFromProjectModal.singular.second' | appTranslate }}</p>
        <p
            [innerHTML]="
                {
                    key: 'time-tracking.removeFromProjectModal.singular.third',
                    params: { employeeName: employeesPendingRemoval[0].fullName, projectName: project.name },
                }
                    | appTranslate
                    | sanitizeHtml
            "
        ></p>
    </ng-container>

    <!-- This is the logic for when there is more than one employee. -->
    <ng-container *ngIf="employeesPendingRemoval.length > 1">
        <ui-banner *ngIf="employeesPendingRemovalWithPendingHours.length" variant="warning" class="margin-bottom-3">
            <div>
                {{
                    {
                        key: 'time-tracking.removeFromProjectModal.plural.bannerWarning',
                        params: { count: employeesPendingRemovalWithPendingHours.length },
                    } | appTranslate
                }}
                <ul class="margin-0 padding-left-2">
                    <li *ngFor="let employee of employeesPendingRemovalWithPendingHours">{{ employee.fullName }}</li>
                </ul>
            </div>
        </ui-banner>
        <p>{{ 'time-tracking.removeFromProjectModal.plural.first' | appTranslate }}</p>
        <p>{{ 'time-tracking.removeFromProjectModal.plural.second' | appTranslate }}</p>
        <p>{{ 'time-tracking.removeFromProjectModal.plural.third' | appTranslate }}</p>
    </ng-container>
</ui-confirmation-dialog>

<div *ngIf="employees?.length > 0">
    <div class="flex align-center space-between middle margin-y-3">
        <app-search #searchBar placeholder="search" (onSearch)="onSearch($event)"></app-search>
    </div>
    <app-simple-table
        [attr.data-cy]="'assigned-employees-projects-table'"
        [columns]="columns"
        [rows]="rows"
        [sticky]="true"
        [fixedHeight]="true"
        [showMeatballs]="true"
        [showEditItem]="false"
        [showDeleteItem]="allowModification"
        [showMeatballs]="allowModification"
        (deleteClicked)="removeEmployee($event)"
        [deleteText]="'time-tracking.remove'"
    ></app-simple-table>
</div>

<div [class.loading]="isLoading">
    <p class="neutral-dark" *ngIf="employees.length === 0">
        {{ 'time-tracking.noEmployeesAssignedToProject' | appTranslate }}
    </p>
    <ui-button *ngIf="allowModification" (click)="openEmployeeSelect()" type="primary">{{
        'time-tracking.addOrRemoveEmployees' | appTranslate
    }}</ui-button>
</div>
